import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordResetComponent } from 'projects/components/page-components/password-reset/password-reset.component';

@Component({
  selector: 'pay-login-password-reset-page',
  imports: [PasswordResetComponent],
  templateUrl: './password-reset-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordResetPageComponent implements OnInit {
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _router = inject(Router);

  token!: string;

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe((params) => {
      this.token = params['token'];

      if (this.token == null) {
        this._router.navigate(['/']);
      }
    });
  }

  routeToNextPage() {
    this._router.navigate(['/'], {
      queryParams: { referrer: 'password-reset' },
    });
  }
}
